<template>
  <div>
    <nav class="navbar" v-bind:class="[super_user ? 'has-background-danger' : 'has-background-link']" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">

        <router-link to="/" class="navbar-item">
            <img src="/static/images/head_images.png">
        </router-link>

        <a role="button" class="navbar-burger burger" v-bind:class="{ 'is-active': menuActive }" v-on:click="menuToggle()" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div id="navbarBasicExample" class="navbar-menu" v-bind:class="{ 'is-active': menuActive }">
        <!-- <div class="navbar-start">
          <a class="navbar-item">
            Home
          </a>

          <a class="navbar-item">
            Documentation
          </a>

          <div class="navbar-item has-dropdown is-hoverable">
            <a class="navbar-link">
              More
            </a>

            <div class="navbar-dropdown">
              <a class="navbar-item">
                About
              </a>
              <a class="navbar-item">
                Jobs
              </a>
              <a class="navbar-item">
                Contact
              </a>
              <hr class="navbar-divider">
              <a class="navbar-item">
                Report an issue
              </a>
            </div>
          </div>
        </div> -->

        <div class="navbar-end">
          <div class="navbar-item">
            <span v-if="isLogin">
              <button class="button" @click="logout">
                ログアウト
              </button>
            </span>
            <span v-else>
              <div class="navbar-item">
                <RouterLink class="button" to="/login">
                  ログイン
                </RouterLink>
              </div>
            </span>
          </div>
        </div>
      </div>
    </nav>
    <div v-if="!super_user && isLogin">
      <div class="hero">
        {{ username }} さん ログイン中
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

export default {
  components: {
  },
  data: function(){
    return {
      showForm: false,
      menuActive:false,
    }
  },
  computed: {
    ...mapState({
      apiStatus: state => state.auth.apiStatus,
    }),
    ...mapGetters({
      isLogin: 'auth/check',
      super_user: 'auth/super_user',
      username: 'auth/username',
    })
  },
  methods: {
    async logout () {
      await this.$store.dispatch('auth/logout')
      if (this.apiStatus) {
        this.$router.push('/login')
      }
    },
    menuToggle(){
      this.menuActive = !this.menuActive;
    },
  }
}
</script>

<style scoped>
  .hero {
    text-align: right;
    margin-right: 20px;
    margin-top: 10px;
  }
</style>